export default {
  betDisplay(item, t) {
    var result = "";
    switch (item.bet_type) {
      case "PARLAY":
        result = "";
        break;
      case "HDP":
      case "HDPH":
        let lang = t.$store.getters.language;
        if(item.home_away == 1) {
          var home = item["home_name_" + lang];
          if (home != null && home != "") {
            result = home;
            break;
          }
          result = item.home_team_name;
        } else {
          var away = item["away_name_" + lang];
          if (away != null && away != "") {
            result = away;
            break;
          }
          result = item.away_team_name;
        }
        break;
      case "OU":
      case "OUH":
        result = item.home_away == 1 ? t.$t("ui.over") : t.$t("ui.under");
        break;
      case "OE":
      case "OEH":
      case "OEHM":
      case "OEHMH":
      case "OEAW":
      case "OEAWH":
        result = item.home_away == 1 ? t.$t("ui.odd") : t.$t("ui.even");
        break;
      case "ML":
      case "MLH":
        result = item.home_away == 1 ? t.$t("m.BT_H") : t.$t("m.BT_A");
        break;
      case "1X2":
        switch (item.home_away) {
          case 1:
            result = t.$t("m.BT_FT1");
            break;
          case 2:
            result = t.$t("m.BT_FT2");
            break;
          case 3:
            result = t.$t("m.BT_FTX");
            break;
        }
        break;
      case "1X2H":
        switch (item.home_away) {
          case 1:
            result = t.$t("m.BT_HT1");
            break;
          case 2:
            result = t.$t("m.BT_HT2");
            break;
          case 3:
            result = t.$t("m.BT_HTX");
            break;
        }
        break;
      case "1X2HDP":
      case "1X2HDPH":
        switch (item.home_away) {
          case 1:
            result = t.$t("m.BT_H");
            break;
          case 2:
            result = t.$t("m.BT_A");
            break;
          case 3:
            result = t.$t("m.BT_D");
            break;
        }
        break;
      case "CS":
      case "CSH":
      case "TG":
      case "TGH":
      case "OR":
      case "BS":
        result = item.criteria1;
        break;
      case "CSHTFT":
      case "ETGHTFT":
        if (item.odds_col_criteria) {
          result = item.criteria1 + " / " + item.odds_col_criteria;
        } else if (item.criteria2) {
          let criteria2Display = item.criteria2;
          if (typeof criteria2Display === "string" && criteria2Display.trim().charAt(0) === "{") {
            try {
              const parsed = JSON.parse(criteria2Display);
              if (parsed && parsed.odds_col_criteria != null) {
                criteria2Display = "<" + parsed.odds_col_criteria + ">";
              }
            } catch (e) {
              // criteria2 is plain text (e.g. parlay leg details), use as-is
            }
          }
          result = item.criteria1 + " / " + criteria2Display;
        } else {
          result = item.criteria1 + " / " + "-";
        }
        break;
      case "HTFT":
      case "HTFTH":
      case "FGLG":
      case "FGLGH":
      case "CL":
      case "HNB":
      case "ANB":
      case "DNB":
      case "DNBH":
      case "TWTN":
      case "ETG":
      case "ETGH":
      case "EHTG":
      case "EHTGH":
      case "EATG":
      case "EATGH":
        result = t.$t("m.BT_" + item.criteria1);
        break;
      case "WM":
      case "HTFTOE":
        result = t.$t("m.BK_" + item.criteria1);
        break;
      case "1X2OU":
      case "DCOU":
        result = t.$t("m.BT_" + item.criteria1) + ` (${item.criteria2})`;
        break;
      case "OUOE":
        result = t.$t("m.BK_" + item.criteria1) + ` (${item.criteria2})`;
        break;
      case "DC":
      case "DCH":
        result = t.$t("m.BT_" + item.criteria1 + "_DC");
        break;
    }

    return result;
  },
  ballDisplay(item, t) {
    var result = null;
    switch (item.bet_type) {
      case "HDP":
      case "HDPH":
        result = item.ball.toString();
        break;
      case "OU":
      case "OUH":
        result = item.ball.toString();
        break;
      case "1X2HDP":
      case "1X2HDPH":
        result = this.ballDisplay3way(item.home_away, item.ball_home_3way, t);
        break;
    }

    return result;
  },
  ballDisplayMMO1(v, g, b, bt, t) {
    // var result = parseInt(item.ball_display);
    // switch (item.bet_type) {
    //   case "HDP":
    //   case "HDPH":
    //     if (item.bet_team_id == item.team_g) {
    //       result = 0 - result;
    //     } else {
    //       result = result;
    //     }
    //     break;
    //   case "OU":
    //   case "OUH":
    //     if (item.bet_team_id == item.team_g) {
    //       result = result;
    //     } else {
    //       result = result;
    //     }
    //     break;
    //   case "1X2HDP":
    //   case "1X2HDPH":
    //     result = this.ballDisplay3way(item.home_away, item.ball_home_3way, t);
    //     break;
    // }

    // return result;
    // if (v == null || v == "") {
    //   return null;
    // }

    var result = v;
    switch (bt) {
      case "HDP":
      case "HDPH":
        if (b != g + 1) {
          if (result != 0) {
            result = "-" + result.toString();
          }
        } else {
          if (result != 0) {
            result = "+" + result.toString();
          }
        }
        break;
      case "OU":
      case "OUH":
        // if (v.includes("-")) {
        //   var balls = v.split("-");
        //   result = (parseFloat(balls[0]) + parseFloat(balls[1])) / 2;
        // }
        break;
      case "1X2HDP":
      case "1X2HDPH":
        result = this.ballDisplay3way(b, result, t);
        break;
      default:
        result = null;
        break;
    }

    return result;
  },
  ballDisplayMMO2(item, t) {
    var result = parseInt(item.ball_display);
    var giving = item.home_giving ? 1 : 0;
    switch (item.bet_type) {
      case "HDP":
      case "HDPH":
        if (item.home_away != giving + 1) {
          result = 0 - result;
        }
        break;
      case "OU":
      case "OUH":
        break;
      default:
        result = null;
        break;
    }

    return result;
  },
  ballDisplay1(item, t) {
    var result = null;
    switch (item.bet_type) {
      case "HDP":
      case "HDPH":
        if (item.bet_team_id == item.team_g) {
          if (item.ball != 0) {
            result = "-" + item.ball.toString();
          } else {
            result = item.ball.toString();
          }
        } else {
          result = item.ball.toString();
        }
        break;
      case "OU":
      case "OUH":
        result = item.ball.toString();
        break;
      case "1X2HDP":
      case "1X2HDPH":
        result = this.ballDisplay3way(item.home_away, item.ball_home_3way, t);
        break;
    }

    return result;
  },
  ballDisplay2(v, g, b, bt, t) {
    if (v == null || v == "") {
      return null;
    }

    var result = v;
    switch (bt) {
      case "HDP":
      case "HDPH":
        if(typeof v == "string") {
          if (v.includes("-")) {
            var balls = v.split("-");
            result = (parseFloat(balls[0]) + parseFloat(balls[1])) / 2;
          }
        }
        if (b != g + 1) {
          if (result != 0) {
            result = "-" + result.toString();
          }
        }
        break;
      case "OU":
      case "OUH":
        if(typeof v == "string") {
          if (v.includes("-")) {
            var balls = v.split("-");
            result = (parseFloat(balls[0]) + parseFloat(balls[1])) / 2;
          }
        }
        break;
      case "1X2HDP":
      case "1X2HDPH":
        result = this.ballDisplay3way(b, result, t);
        break;
      default:
        result = null;
        break;
    }

    return result;
  },
  ballDisplay3(v, g, b, bt, t) {
    if (v == null || v == "") {
      return null;
    }

    var result = v;
    switch (bt) {
      case "HDP":
      case "HDPH":
        if (v.includes("-")) {
          var balls = v.split("-");
          result = (parseFloat(balls[0]) + parseFloat(balls[1])) / 2;
        }
        if (b != g + 1) {
          if (result != 0) {
            result = "-" + result.toString();
            // if(b == g) {
            //   result = "-" + result.toString();
            // } else {
            //   result = "+" + result.toString();
            // }
          } else {
            // result = "+" + result.toString();
          }
        } else {
          if (result != 0) {
            result = "+" + result.toString();
          }
        }
        break;
      case "OU":
      case "OUH":
        if (v.includes("-")) {
          var balls = v.split("-");
          result = (parseFloat(balls[0]) + parseFloat(balls[1])) / 2;
        }
        break;
      case "1X2HDP":
      case "1X2HDPH":
        result = this.ballDisplay3way(b, result, t);
        break;
      default:
        result = null;
        break;
    }

    return result;
  },
  ballDisplayMMO(v, g, b, bt, c) {
    var result = {
      ball_display: parseInt(v),
      criteria2: parseFloat(c)
    };
    switch (bt) {
      case "HDP":
      case "HDPH":
        if (b != g + 1) {
          result.ball_display = 0 - result.ball_display;
        } else {
          result.criteria2 = 0 - result.criteria2;
        }
        break;
      case "OU":
      case "OUH":
        if (b == g + 1) {
          result.criteria2 = 0 - result.criteria2;
        }
        break;
      default:
        result = null;
        break;
    }

    return result;
  },
  ballDisplay3way(b, v, t) {
    var result = v;
    switch (b) {
      case 1:
        if (result > 0) {
          result = "+" + result;
        } else {
          if (result < 0) {
            result = result.toString();
          }
        }
        break;
      case 2:
        if (result > 0) {
          result = "-" + result;
        } else {
          if (result < 0) {
            result = "+" + (-result).toString();
          }
        }
        break;
      case 3:
        if (result > 0) {
          result = t.$t("m.BT_H") + "+" + result;
        } else {
          if (result < 0) {
            result = t.$t("m.BT_A") + "+" + (-result).toString();
          }
        }
        break;
    }
    return result;
  },
  parlayResult(payout, display, t) {
    switch (true) {
      case payout === 0:
        return t.$t("ui.lost");
      case payout === 1:
        return t.$t("ui.draw");
      case payout > 0 && payout < 1:
        return t.$t("ui.lost_half");
      case payout / 2 === display:
        return t.$t("ui.won_half");
      case payout > 1:
        return t.$t("ui.won");
      default:
        return "Running";
    }
  },
  chooseBetType(choosenSport, menu, menu3) {
    var betTypes = [];
    for (var mm in menu[choosenSport]) {
      if (menu[choosenSport][mm] > 0) {
        switch (mm) {
          case "st":
          case "mt":
          case "lv":
          case "tn":
          case "hdp":
          case "ou":
          case "ml":
            break;
          case "pl":
            betTypes.push("parlay");
            break;
          default:
            betTypes.push(mm);
            break;
        }
      }
    }
    var sortedBetTypes = ["hdpou", "oxt", "cs", "oe", "dc", "tg", "htft", "fglg", "parlay", "orz"];
    let intersection = sortedBetTypes.filter(x => betTypes.includes(x));
    var choosenBetType = "hdpou";
    if (!intersection.includes(choosenBetType)) {
      choosenBetType = intersection[0];
    }

    return choosenBetType;
  },
  matchStatus(ht, ft) {
    var status = "";

    switch (ht) {
      case 0:
        switch(ft) {
          case 0:
            status = "ui.match_pending";
            break;
          case 1:
            status = "ui.match_completed";
            break;
          case 2:
            status = "ui.match_cancelled";
            break;
          case 5:
            status = "ui.match_suspended";
            break;
        }
        break;
      case 1:
        switch(ft) {
          case 0:
            status = "ui.running";
            break;
          case 1:
            status = "ui.match_completed";
            break;
          case 2:
            status = "ui.match_cancelled_2h";
            break;
          case 5:
            status = "ui.match_suspended_2h";
            break;
        }
        break;
      case 2:
        switch(ft) {
          case 0:
            status = "ui.running";
            break;
          case 1:
            status = "ui.match_cancelled_1h";
            break;
          case 2:
            status = "ui.match_cancelled";
            break;
          case 5:
            // status = "ui.match_suspended_2h";
            break;
        }
        break;
      case 5:
        switch(ft) {
          case 0:
            status = "ui.match_pending";
            break;
          case 1:
            status = "ui.match_suspended_1h";
            break;
          case 2:
            // status = "ui.match_cancelled";
            break;
          case 5:
            status = "ui.match_suspended";
            break;
        }
        break;
    }

    return status;
  }
};
